import styled from "@emotion/styled";
import { Box, Button, Select, MenuItem } from "@mui/material";

export const PaginationContainer = styled(Box)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0 8px 16px;
  width: 100%;
`;

export const LeftSection = styled(Box)`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const PaginationInfo = styled(Box)`
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 10px;
  color: #666;
  margin-left: 8px;
`;

export const EntriesContainer = styled(Box)`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: #666;
`;

export const StyledSelect = styled(Select)`
  height: 32px;
  width: 70px;
  font-size: 14px;
  color: #2A2A2A;
  border-color: #E0E0E0;
  border-radius: 4px;
  
  .MuiOutlinedInput-notchedOutline {
    border-color: #E0E0E0;
  }
  
  &:hover .MuiOutlinedInput-notchedOutline {
    border-color: #2A2A2A;
  }
`;

export const PaginationButton = styled(Button)`
  width: 32px;
  height: 32px;
  border-radius: 4px;
  border-width: 1px;
  min-width: auto;
  padding: 6px;
  margin: 0 5px;
  background-color: white;
  opacity: ${props => props.isActive ? 1 : 0.5};
  color: ${props => props.isActive ? "#2A2A2A" : "#BABABA"};
  border-color: ${props => props.isActive ? "#2A2A2A" : "#BABABA"};

  &:hover {
    background-color: #f8f9fa;
  }
`;

export const NavigationButton = styled(Button)`
  width: 32px;
  height: 32px;
  border-radius: 4px;
  border-width: 1px;
  min-width: auto;
  padding: 6px;
  margin: 0 5px;
  background-color: white;
  opacity: ${props => props.disabled ? 0.5 : 1};
  color: ${props => props.disabled ? "#BABABA" : "#2A2A2A"};
  border-color: ${props => props.disabled ? "#BABABA" : "#2A2A2A"};

  &:hover {
    background-color: #f8f9fa;
  }
`; 